module.exports = __webpack_public_path__ + "booking.com-logo.png?ba2eef5986a8f499efa6e5bd3b5ab4b4";